<template>
  <v-container>
      <v-flex>
        <div>
          <v-data-table
                  :headers="headers"
                  :items="this.procedures"
                  class="elevation-1"
                  sort-icon="mdi-menu-down"
                  :search="search"
                  hide-actions
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">
                <span v-if="props.item.disableAprobar"> Anexo cargado</span>
                <span v-if="!props.item.disableAprobar"> Anexo sin cargar</span>

              </td>
              <td>
                <v-checkbox  v-model="props.item.selectedAprobar" >
                </v-checkbox>
              </td>
              <td>
                <v-checkbox
                        v-model="props.item.selectedPendiente" >
                </v-checkbox>
              </td>
              <td>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              No se han encontrado resultados para "{{ search }}".
            </v-alert>
          </v-data-table>
          <div class="text-xs-center">
            <v-btn color="primary" v-if="this.procedures.length>0 && this.$store.state.routeSheet.status=='true'" @click="save" dark>Guardar</v-btn>
          </div>
        </div>
      </v-flex>

    <v-dialog
            v-model="dialogError"
            max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span>Por favor verifique la información requerida para continuar.</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
                  color="primary"
                  text
                  @click="dialogError = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="dialogSuccess"
            max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span>Se guardó con exito la información</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
                  color="primary"
                  text
                  @click="dialogSuccess = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>

  import PatientHojaRuta from "../../../model/PatientHojaRuta";

  export default {
    data () {
      return {
        search: '',
        valid: false,
        date:"",
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        dialogError: false,
        dialogSuccess: false,
        headers: [
          { text: 'Examen', value: 'date' },
          { text: 'Detalle', value: 'detalle' },
          { text: 'Aprobar', value: 'place' },
          { text: 'Pendiente', value: 'role' },
        ],
        itemsPlace:['Quito','Guayaquil','Ambato','Cuenca'],
        itemsRole:['ADMINISTRATIVO','OPERATIVO'],
        itemsType:['PRE','INI', 'OCU', 'REU','ESP','RET', 'REI'],
        itemsCaducity:['1 dias','2 dias','3 dias', '4 dias','5 dias','6 dias', '7 dias','8 dias','9 dias','10 dias', '11 dias','12 dias','13 dias', '14 dias','15 dias','30 dias'],
        editedIndex: -1,
        hojaRuta: new PatientHojaRuta(),
        hojasRuta:[],
        hojasRutaData:[],
        menu: false,
        routeSheet:"",
        exams:[],
        procedures:[],
        routeSheetStatus:{}
      };
    },methods:{
      cleanData(){
        this.$refs.form.reset()
        this.hojaRuta = new PatientHojaRuta()
        this.valid = false
        this.dialog = false
        this.menu= false
        this.date=""
        this.procedures=[]
        this.exams=[]
      },
      newHojaRuta(){
        this.editedIndex = -1
        this.valid = false
        this.dialog = true
        //this.$refs.form.reset()
        this.hojaRuta = new PatientHojaRuta()
        this.menu= false
        this.date=""
      },
      saveData(){

          if(this.valid) {

          }else{
            this.dialogError=true
          }
      },



      editItem (item) {
        this.editedIndex = this.$store.state.hojasRuta.indexOf(item)
        this.hojaRuta = Object.assign({}, item)
        this.procedures = this.hojaRuta.procedures
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.$store.state.hojasRuta.indexOf(item)
        this.hojaRuta = Object.assign({}, item)
        confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientRouteSheet',this.hojaRuta)
      },
      changeStatusItem (item) {
        this.editedIndex = this.$store.state.hojasRuta.indexOf(item)
        this.hojaRuta = Object.assign({}, item)
        this.hojaRuta.status = false
        confirm('Está seguro que desea cerrar la Hoja de Ruta? No podrá realizar cambios a la hoja de ruta') &&   this.$store.dispatch('updatePatientRouteSheet',this.hojaRuta).then(response => {
        }, error => {
          this.$store.dispatch('getPatientRouteSheetsByPatient',this.hojaRuta.patient.id)
        })
      },
      save() {
        this.$store.state.routeSheet.status = false
        confirm('Está seguro que desea cerrar la Hoja de Ruta? No podrá realizar cambios a la hoja de ruta') &&   this.$store.dispatch('updatePatientRouteSheet',this.$store.state.routeSheet).then(response => {
          for(let i=0; i<this.procedures.length; i++) {
            this.routeSheetStatus = new Object()
            this.routeSheetStatus.date = new Date()
            this.routeSheetStatus.approbe = this.procedures[i].selectedAprobar
            this.routeSheetStatus.pending = this.procedures[i].selectedPendiente
            this.routeSheetStatus.patientRouteSheet = this.$store.state.routeSheet
            this.routeSheetStatus.idProcedure = this.procedures[i].id
            this.routeSheetStatus.user = this.$store.state.userInSession
            this.routeSheetStatus.user.company = null
            this.routeSheetStatus.id = this.procedures[i].idStatus
            if (this.routeSheetStatus.id != null) {
              this.$store.dispatch('updatePatientRouteSheetStatus', this.routeSheetStatus).then(response => {
                this.dialog = false
                this.dialogSuccess = true
              }, error => {
                this.$store.state.progress = false
                this.$store.state.dialogError = true
              })
            } else {
              this.$store.dispatch('addPatientRouteSheetStatus', this.routeSheetStatus).then(response => {
                this.dialog = false
                this.dialogSuccess = true
              }, error => {
                this.$store.state.progress = false
                this.$store.state.dialogError = true
              })
            }
            if(i==this.procedures.length){
              this.reload()
            }
          }
        }, error => {
          this.$store.dispatch('getPatientRouteSheetsByPatient',this.hojaRuta.patient.id)
        })

      },
      reload(){
        let anamnesisExamenFisico = 0
        this.$store.dispatch('getPatientAnamnesisByRouteSheets', this.$store.state.routeSheet.id).then(response => {
          if (this.$store.state.anamnesisList.length > 0) {
            anamnesisExamenFisico++;
          }
          this.$store.dispatch('getPatientJobAndHealthByRouteSheets', this.$store.state.routeSheet.id).then(response => {
            this.listAnexoSaludTrabajo = []
            if (this.$store.state.workAndHealthList.length > 0) {
              anamnesisExamenFisico++;
            }
            this.procedures = []
            this.$store.dispatch('getPatientFileByRouteSheets', this.$store.state.routeSheet.id).then(response => {
              this.$store.dispatch('getPatientRouteSheetsByPatient', this.$store.state.patient.id).then(response => {
                for (let i = 0; i < this.$store.state.hojasRuta.length; i++) {
                  if (this.$store.state.hojasRuta[i].id == this.$store.state.routeSheet.id) {
                    let proceduresDb = JSON.parse(this.$store.state.hojasRuta[i].detail)
                    for (let j = 0; j < proceduresDb.length; j++) {
                      if (proceduresDb[j].selected == true) {
                        proceduresDb[j].selectedAprobar = false
                        proceduresDb[j].selectedPendiente = false
                        proceduresDb[j].disableAprobar = false
                        for (let k = 0; k < this.$store.state.patientFileList.length; k++) {
                          if (this.$store.state.patientFileList[k].group.includes(proceduresDb[j].name)) {
                            proceduresDb[j].disableAprobar = true
                            break
                          }
                          if (proceduresDb[j].name == 'ANAMNESIS Y EXAMEN FÍSICO' && anamnesisExamenFisico == 2) {
                            proceduresDb[j].disableAprobar = true
                            break
                          }
                        }
                        this.$store.dispatch('getPatientRouteSheetStatusByRouteSheets', this.$store.state.routeSheet.id).then(responseStatus => {
                          for (let l = 0; l < responseStatus.data.length; l++) {
                            if (proceduresDb[j].id == responseStatus.data[l].idProcedure) {
                              proceduresDb[j].selectedAprobar = responseStatus.data[l].approbe
                              proceduresDb[j].selectedPendiente = responseStatus.data[l].pending
                              proceduresDb[j].idStatus = responseStatus.data[l].id
                              break
                            }
                          }
                          this.procedures.push(proceduresDb[j])
                        })

                      }
                    }
                  }
                }
              })
            })
          }, error => {
            this.$store.state.progress = false;
            this.$store.state.dialogError = true;
          })
        }, error => {
          this.$store.state.progress = false;
          this.$store.state.dialogError = true;
        })
      }
    },
    computed : {
    },
    beforeCreate(){
      this.$store.dispatch('getCompanies').then(response => {
      })
      this.$store.dispatch('getProcedures').then(response => {
      })
    },
    created() {
      this.reload();


    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patient/ruta/Ruta.vue